<template>
  <v-overlay v-model="loader" style="z-index: 999">
    <v-progress-circular
        indeterminate
        size="64"
    />
  </v-overlay>
</template>
<script>
export default {
  name: 'Loader',
  data: () => ({
    loader: false
  }),
  methods: {
    show() {
      this.loader = true;
    },
    hide() {
      this.loader = false;
    }
  }
}
</script>